import { cn } from '@foam/buoy/src/lib/utils';
import React from 'react';

import { TooltipData, TooltipPosition } from './CursorTooltip.types';

interface TooltipContentProps {
  tooltipRef: React.RefObject<HTMLDivElement>;
  isVisible: boolean;
  position: TooltipPosition;
  tooltipData: TooltipData;
}

export const TooltipContent: React.FC<TooltipContentProps> = ({
  tooltipRef,
  isVisible,
  position,
  tooltipData,
}) => {
  return (
    <div
      ref={tooltipRef}
      className={cn(
        'pointer-events-none fixed z-10 transition-all duration-300 ease-out',
        {
          'invisible scale-75 opacity-0': !isVisible,
          'visible scale-100 opacity-100': isVisible,
        },
      )}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: `${position.width}px`,
        willChange: 'opacity, transform, left, top, width',
      }}
    >
      <div className="flex flex-col items-start rounded-12 bg-neutral-700 p-4 shadow-lg">
        <h3 className="text-20 font-500 text-neutral-0">{tooltipData.title}</h3>
        <p className="text-16 font-400 text-neutral-0">{tooltipData.content}</p>
      </div>
    </div>
  );
};
